import { Form } from "antd";
import { useEffect } from "react";

import { useReferentialLanguages } from "@/entities/referential/referential-languages";

export const useLanguageSelectField = () => {
  const { languages, defaultLanguage, isLoading } = useReferentialLanguages();
  const { useFormInstance } = Form;

  const form = useFormInstance();

  const currentValue = form.getFieldValue("language");
  useEffect(() => {
    if (!currentValue && defaultLanguage) {
      // set defaultValue if there is no value in the form
      form.setFieldsValue({ language: defaultLanguage.code });
    }
  }, [defaultLanguage, currentValue]);

  return { languages, isLoading };
};
